import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
//import * as flightInfoTypes from './flightInfoTypes'

const useStyles = makeStyles(theme => ({

    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },

}));
const Passenger = (props) => {
    console.info("passenger header", props);

    let { selectedFlightInfo} = props
    console.info("passenger header selectedFlightInfo", selectedFlightInfo);
    let paxDetails = []
    let totalPax  =  0
    if (selectedFlightInfo.PassengerDetails != null) {
        paxDetails = selectedFlightInfo.PassengerDetails.filter(pax => pax.Direction == '2' && pax.Confirmed > 0)
        totalPax = paxDetails.length;
        console.info("paxDetails", paxDetails);
        console.info("totalPax", totalPax);
      }      

      //Ss started
      var demo = selectedFlightInfo.FltNumInbound;      
      //FltNumInbound: "282"
      console.info("FltNumInbound",demo);   
      
      if(selectedFlightInfo.PassengerDetails != null)
      {
      const hello = selectedFlightInfo.PassengerDetails.filter(dd=> {
        //console.info("selectedFlightInfo.FltNumInbound",parseInt(selectedFlightInfo.FltNumInbound));
        //console.info("dd string",dd);
        //console.info("dd.FlightNumber",dd.FlightNumber)
        //console.info("dd string",(dd.FlightNumber == parseInt(selectedFlightInfo.FltNumInbound) &&
        //dd.ArrivalStation == 'YTZ'));
          return (dd.FlightNumber == parseInt(selectedFlightInfo.FltNumInbound) &&
          dd.ArrivalStation == 'YTZ') 
          
          //console.info("final list",hello);
      });
    }

      //console.info("final list",hello);
      
      

      //var p1 = selectedFlightInfo.PassengerDetails;
      //console.info("Only passenger", p1);

      //var hello = selectedFlightInfo.PassengerDetails[0].FlightNumber;
      //if (selectedFlightInfo.PassengerDetails != null) {
      //var hello = selectedFlightInfo.PassengerDetails.filter(dd=> dd.FlightNumber == demo};
     // console.info("hello",hello);      
     // }

      // filter of array
      
      

      
      //Ss ended
    const [expanded, setExpanded] = React.useState(false);
    const classes = useStyles();
    function handleExpandClick() {
        setExpanded(!expanded);
    }
    return (
        <div className="floatRight">Total Outbound Passengers: {totalPax}
              {/* <ExpansionPanel className="passengerSummary">
              <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
              >Details </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                  blah
              </ExpansionPanelDetails>

          </ExpansionPanel> */}
        </div>
    )
}

export default Passenger